<mat-sidenav-container
  ngClass.gt-sm="large-screen"
  [class]="prepareRouterTheme(outlet) || ''"
>
  <mat-sidenav
    fixedInViewport
    fixedTopGap="0"
    fixedBottomGap="0"
    [mode]="(mediumScreenState | async)?.matches ? 'over' : 'side'"
    [opened]="!(mediumScreenState | async)?.matches"
    class="mat-elevation-z4 dark"
    #menu
  >
    <mat-toolbar color="primary">
      <mat-icon class="logo" svgIcon="atom"></mat-icon>
      <h1>Atom</h1>
      <span class="env-name mat-caption">{{ environmentName }}</span>
    </mat-toolbar>
    <atm-main-menu></atm-main-menu>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar class="mat-elevation-z3">
      <button class="menu-toggle" mat-icon-button (click)="menu.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <h2
        *ngIf="
          outlet.isActivated && (outlet.activatedRoute.data | async) as data
        "
      >
        {{ data["title"] }}
      </h2>
      <span class="separator"></span>
      <atm-dark-mode-toggle></atm-dark-mode-toggle>
      <mat-divider vertical></mat-divider>
      <atm-user-menu></atm-user-menu>
    </mat-toolbar>
    <main [@routeSwap]="prepareRouterAnimation(outlet)">
      <router-outlet #outlet="outlet"></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
